export const getThemeConfig=()=>{
    let themeConfig=['loginFlex-padding'                  
                    ,'loginPanel-bg'
                    ,'loginPanel-border'

                    ,'body-bg'  
                    ,'body-bg-repeat' 
                    ,'body-bg-position'
                    ,'container-margin'
                    ,'container-padding'
                    ,'container-radius'
                    ,'container-shadow' 
                    ,'fnForm-bg'                   
                    ,'header-bg'
                    ,'header-bg-repeat'
                    ,'header-bg-position'
                    ,'header-shadow'
                    ,'header-color'                 
                    ,'button-bg'
                    ,'button-color'
                    ,'button-radius'
                    ,'button-hover-bg'
                    ,'navOpen-bg'
                    ,'menu-bg'
                    ,'menu-bg-repeat' 
                    ,'menu-bg-position'
                    ,'menu-bg-shadow'
                    ,'menu-hover-bg'
                    ,'menu-color'
                    ,'menu-icon'
                    ,'menu-arrow'                    
                    ,'menu-li-bg'
                    ,'menu-li-img'
                    ,'menu-li-padding'
                    ,'menu-selected-img'                    
                    ,'menu-selected-color'
                    ,'menu-selected-bg'
                    ,'menu-selected-border'
                    ,'menu-selected-radius'                                        
                    ,'menu-selected-arrow'
                    ,'menu-selected-arrow-size'
                    ,'menu-padding'
                    ,'fnbuttons-bg'
                    ,'fnbuttons-color'
                    ,'fnbuttons-border'
                    ,'fnbuttons-shadow'
                    ,'fnbuttons-hover-bg'                    
                    ,'grid-bg'
                    ,'grid-th-color'
                    ,'grid-odd-bg'
                    ,'grid-even-bg'                    
                    ,'grid-tr-hover-bg'   
                    ,'grid-tr-hover-color'                 
                    ,'grid-numbers-border'
                    ,'form-th-bg'
                    ,'form-th-color'
                    ,'form-td-bg'
                    ,'form-border'
                    ,'kdialog-bg'
                    ,'kdialog-color'
                    ,'footer-bg'
                    ,'footer-color'
                    ,'footer-text'

                    
                    
                    
                    
                ];

    return themeConfig;
}